export default import.meta.ROLLUP_FILE_URL_4dOZt12ZXQys8plSY_JAfw